import WordsCloudReducer from './WordsCloudReducer';
import { ProfilesListReducers } from './containers/ProfilesList';

export default from './WordsCloudContainer';
export const WordsCloudReducers = {
  WordsCloudReducer,
  ...ProfilesListReducers,
};
